var call = require('../internals/function-call');
var createAsyncIteratorProxy = require('../internals/async-iterator-create-proxy');

module.exports = createAsyncIteratorProxy(function () {
  return call(this.next, this.iterator);
}, true);



//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/web/app/themes/mea/node_modules/core-js/internals/async-iterator-wrap.js
// module id = 356
// module chunks = 0